import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl
} from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { CrudService } from '../../../crud/crud.service';
import { NotificationsService } from 'angular2-notifications';

import { Mensaje } from '../../../mensaje';

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
import * as moment from 'moment';

import { materialize } from 'rxjs/operators';
import { NULL_EXPR } from '@angular/compiler/src/output/output_ast';

import { HttpClient, HttpHeaders, HttpResponse  } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';

@Component({
  selector: 'app-repeticion',
  templateUrl: './repeticion.component.html',
  styles: ['ngui-auto-complete {z-index: 999999 !important}']
})
export class RepeticionComponent implements OnInit{
  dato = {};
  data = {};
  docentes = [];
  materias = [];
  grupos = [];
  repeticiones_materias = [];
  carrera_modulo_nivel;
  periodos_escolares_niveles;
  grupos_niveles;
  carrera_plan;
  cargando = false;

  borrarCargando = false;

  mensajeResponse: Mensaje = new Mensaje(true);
  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };
  time_cal;

  empresa = localStorage.getItem("empresa");
  sucursal = localStorage.getItem("sucursal");
  public alumnos_term: string = `${
    environment.API_URL
  }/alumnos-repetir?term=:keyword&empresa=${this.empresa}&sucursal=${
    this.sucursal
  }`;

  tieneid: boolean = false;

  auto = 0;

  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  usuario = JSON.parse(localStorage.getItem("usuario"));

  json;
  alumnos = {
    id: "",
    matricula: "",
    alumnos_metadatos: {
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      matricula: ""
    },
    grupos: {
      nombre: "",
      clave: "",
      identificador: "",
      nivel: "",
      turnos: {
        nombre: ""
      }
    },
    becas: {
      importe: 0
    },
    carrera_plan: {
      id: "",
      nombre: ""
    },
    carreras_planes: {
      id: "",
      nombre: ""
    }
  };

  periodos_escolares;
  documentos = [];

  constructor(
    private crudService: CrudService,
    private route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private http: HttpClient,
    private notificacion: NotificationsService
  ) {}

  observableSource = (keyword: any): Observable<any[]> => {
    
    let url: string =  `${environment.API_URL}/alumnos-auto?term=${keyword}&empresa=${this.empresa}&sucursal=${this.sucursal}`
    if (keyword) {
      return this.http.get(url).pipe(map((response: HttpResponse<any>) => {
        let data: any = response;
        return data.data;
      }));
        
    } else {
      return Observable.bind([]);
    }
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.tieneid = true;
      }
    });
    //this.dato[0] = 0;
    this.dato = {
      id: null,
      periodos_escolares_id: null,
      materias_id: null,
      grupos_id: null
    };
    
    this.materias[0] = {id:null, clave:"UNKNOWED", nombre:'', nivel: 1, orden:1};
    this.obtenerdocumentos("BOLETAS PARCIALES");
  }
  /**
   * Este método formatea los resultados de la busqueda en el autocomplte
   * @param data resultados de la busqueda
   * @return void
   */
  autocompleListFormatter = (data: any) => {
    if (this.auto == 0) {
      $("ngui-auto-complete").attr(
        "style",
        $("ngui-auto-complete").attr("style") + "z-index:999"
      );
    }
    let html = `
    <div class="card" >
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <h4 style="font-size:1.5em; color:#292929; font-weight: 600;">
            ${data.alumnos_metadatos.nombre} ${
      data.alumnos_metadatos.apellido_paterno
    } ${data.alumnos_metadatos.apellido_materno}
            <small style="font-size: .5em; font-style: italic;">
           ${data.alumnos_metadatos.email}
            </small></h4>
            <h6>
              <strong>CURP: </strong> ${
                data.alumnos_metadatos.curp
              } <strong>Tutor: </strong> ${data.alumnos_metadatos.tutor_nombre}
              `;
    html += `<label class="tag is-success" >Domicilio: ${
      data.alumnos_metadatos.calle
    }, ${data.alumnos_metadatos.no_exterior}, ${
      data.alumnos_metadatos.colonia
    } </label>`;

    html += `<label class="tag is-warning" >CP : ${
      data.alumnos_metadatos.codigo_postal
    }</label>`;

    html += `
            </h6>
          </div>
        </div>
      </div>
    </div>`;
    this.auto++;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  };

  /**
   * Este método agrega los lostes del modal a el modelo que se envia a la api
   * @return void
   */
  select_articulo_autocomplete(data) {
    this.cargando = true;
    this.auto = 0;
    this.repeticiones_materias = [];
    if (!data.alumnos_metadatos.hasOwnProperty("foto")) {
      data.alumnos_metadatos.foto = "";
    }
    if (!data.alumnos_metadatos.hasOwnProperty("avatar")) {
      data.alumnos_metadatos.avatar = "";
    }
    this.alumnos = data;
    document.getElementById("catalogos").click();
    this.cargarDatos(this.alumnos.id);
    (<HTMLInputElement>document.getElementById("buscarArticulo")).value = "";
  }
  cargarDatos(id) {
    // this.dato = [];

    this.dato['id'] = id;
    this.dato['periodos_escolares_id'] = null;
    this.dato['grupos_id'] = null;
    this.dato['materias_id'] = null;

    this.carrera_modulo_nivel = [];
    this.carrera_plan = [];
    this.cargando = true;
    this.crudService.ver(this.alumnos.id, "repeticion").subscribe(
      resultado => {
        if (resultado.status == 200) {
          //console.log(document.getElementById("periodos_escolares_id"));
          // this.dato = resultado.data;
          // this.dato['id'] = id;
          // this.dato['grupos_id'] = "cero";
          // this.dato['materias_id'] = "zero";
          //console.log(this.data);
          this.alumnos = resultado.data;
          this.repeticiones_materias = resultado.repeticiones_materias;
          this.alumnos.alumnos_metadatos = resultado.data;
          this.alumnos.carrera_plan  = this.carrera_plan;
          // this.alumnos.alumnos_metadatos.nombre = resultado.data.nombre;
          // this.alumnos.alumnos_metadatos.apellido_materno = resultado.data.apellido_materno;
          // this.alumnos.alumnos_metadatos.apellido_paterno = resultado.data.apellido_paterno;

          this.materias = resultado.materias;

          this.materias.forEach(element => {
            element.text = element.clave+' - '+element.nivel+' : '+element.nombre; 
          });

          
          
          //this.docentes = resultado.docentes;
          // this.carrera_modulo_nivel = resultado.carrera_modulo_nivel;
          // this.periodos_escolares_niveles = resultado.periodos_escolares_niveles;
          // this.grupos_niveles = resultado.grupos_niveles;
          // this.carrera_plan = resultado.carrera_plan;
          // this.periodos_escolares = resultado.periodos_escolares;
        } else {
          this.mensajeResponse.titulo = "No configurado";
          this.mensajeResponse.texto = "No se encontro datos";
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
        this.cargando = false;
      },
      error => {
        this.cargando = false;
        this.mensajeResponse.titulo = "Error";
        this.mensajeResponse.texto = "Algo salio mal";
        this.mensajeResponse.clase = "danger";
        this.mensaje(3);
      }
    );
  }

  sCE(event, element) {
    //this.dato[element] = event.value;
    //this.dato[element] = event.value;
    this.dato[element] = event;
  }

  enviar() {
    this.cargando = true;
    this.json = this.dato;

    document.getElementById("confirmarCalificacion").classList.remove("is-active");
    this.crudService.crear(this.json, "repeticion").subscribe(
      resultado => {
        this.cargando = false;
        if (resultado.status == 200 || resultado.status == 201) {
          this.mensajeResponse.titulo = "Guardado";
          this.mensajeResponse.texto = "Se ha guardado correctamente";
          this.mensajeResponse.clase = "success";
          this.mensaje(3);
        } else {
          this.mensajeResponse.titulo = "No guardado";
          this.mensajeResponse.texto = resultado.messages;
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
      },
      error => {
        this.cargando = false;
        this.mensajeResponse.titulo = "Error";
        this.mensajeResponse.texto = "Ocurrio un error inesperado ";
        this.mensajeResponse.clase = "danger";
        this.mensaje(3);
      }
    );
  }

  validar_max(event, modelo, max) {
    if (
      event.key != "Tab" &&
      event.key != "CapsLock" &&
      event.key != "Shift" &&
      event.key != "ArrowLeft" &&
      event.key != "ArrowRight" &&
      event.key != "ArrowUp" &&
      event.key != "ArrowDown" &&
      event.key != "."
    ) {
      clearTimeout(this.time_cal);
      this.time_cal = setTimeout(() => {
        if (modelo > max) {
          event.srcElement.value = max;
          modelo = max;
          this.mensajeResponse.titulo = "Maximo";
          this.mensajeResponse.texto =
            "El maximo valor para las calificaciones de este nivel es: " + max;
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
      }, 500);
    }
  }

  mensaje(
    cuentaAtras: number = 6,
    posicion: any[] = ["middle", "center"]
  ): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };

    if (this.mensajeResponse.clase == "alert")
      this.notificacion.alert(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "success")
      this.notificacion.success(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "info")
      this.notificacion.info(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "warning" ||
      this.mensajeResponse.clase == "warn"
    )
      this.notificacion.warn(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "error" ||
      this.mensajeResponse.clase == "danger"
    )
      this.notificacion.error(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );
  }
  parametros = {
    pagina: 0,
    limite: 0
  };
  obtenerdocumentos(tipo) {
    this.cargando = true;
    this.crudService.lista(this.parametros, "documentos?tipo=" + tipo).subscribe(
      resultado => {
        if (resultado.status == 200) {
          this.documentos[tipo] = resultado.data;
        } else {
          this.mensajeResponse.titulo = "Documentos";
          this.mensajeResponse.texto = "No configurado";
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
        this.cargando = false;
      },
      error => {
        this.cargando = false;
        this.mensajeResponse.titulo = "Error";
        this.mensajeResponse.texto = "Documentos";
        this.mensajeResponse.clase = "danger";
        this.mensaje(3);
      }
    );
  }

  imprimirParcial(dato) {
    let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");

    var doc = new jsPDF("p", "mm", "letter");

    var header = this.documentos["BOLETAS PARCIALES"]["HEADER"];
    var body = this.documentos["BOLETAS PARCIALES"]["BODY"];
    var footer = this.documentos["BOLETAS PARCIALES"]["FOOTER"];

    var conteo_lienas = 4;
    let nivel = dato[0].nivel;
    if (header) {
      header.forEach(element => {
        var columna = 5;
        var fila = 5;
        var col = 0;
        var fil = 0;
        var col_no = 0;
        var ancho = 0;
        var alto = 0;
        element.estructuras_contenidos.forEach(elem => {
          ancho = 216 * (elem.ancho_porcentaje / 100);
          alto = 279 * (elem.alto_porcentaje / 100);
          col_no = 0;
          if (elem.tipo == "FOTO") {
            doc.addImage(
              elem.logo,
              "PNG",
              columna,
              fila,
              ancho,
              alto,
              "",
              "FAST"
            );
          } else {
            let contenido = elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                    contenido =
                      "<div style='line-height: 20px;'>" +
                      contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                      "</div>";
                      
                    doc.fromHTML(elem.contenido, columna, conteo_lienas, {
                      width: ancho + columna
                    });
          }
          columna += ancho + 1;
          col++;

          if (element.columnas == col) {
            col = 0;
            conteo_lienas += alto;
            columna = 5;
            col_no = 1;
          }
        });
        if (col_no == 0) conteo_lienas += alto;
      });
    }
    if (body) {
      body.forEach(element => {
        var columna = 5;
        var fila = 5;
        var col = 0;
        var fil = 0;
        var col_no = 0;
        var ancho = 0;
        var alto = 0;
        element.estructuras_contenidos.forEach(elem => {
          ancho = 216 * (elem.ancho_porcentaje / 100);
          alto = 279 * (elem.alto_porcentaje / 100);
          col_no = 0;
          if (elem.tipo == "FOTO") {
            doc.addImage(
              elem.logo,
              "PNG",
              columna,
              fila,
              ancho,
              alto,
              "",
              "FAST"
            );
          } else {
            let contenido = elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                    contenido =
                      "<div style='line-height: 20px;'>" +
                      contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                      "</div>";
                      
                    doc.fromHTML(elem.contenido, columna, conteo_lienas, {
                      width: ancho + columna
                    });
          }
          columna += ancho + 1;
          col++;

          if (element.columnas == col) {
            col = 0;
            conteo_lienas += alto;
            columna = 5;
            col_no = 1;
          }
        });
        if (col_no == 0) conteo_lienas += alto;
      });
    }

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "bold");

    doc.text("BOLETA PARCIAL", 108, conteo_lienas, { align: "center" });
    conteo_lienas += 10;
    doc.text(
      "NIVEL: " + this.carrera_plan.carreras.nivel_educativo.toUpperCase(),
      15,
      conteo_lienas,
      { align: "left" }
    );
    conteo_lienas += 5;
    doc.text(
      "CARRERA: " +
      this.carrera_plan.carreras.nombre +
      " - " +
      this.carrera_plan.planes_estudios.nombre,
      15,
      conteo_lienas,
      { align: "left" }
    );
    doc.text(
      "TURNO: " + this.alumnos.grupos.turnos.nombre,
      125,
      conteo_lienas,
      { align: "left" }
    );
    conteo_lienas += 5;
    doc.text(
      "CLAVE: " + this.carrera_plan.carreras.sigla,
      15,
      conteo_lienas,
      { align: "left" }
    );
    doc.text(
      "CICLO: " + this.periodos_escolares_niveles[nivel].nombre,
      125,
      conteo_lienas,
      { align: "left" }
    );
    conteo_lienas += 8;

    doc.text(
      "NOMBRE: " +
      this.alumnos.alumnos_metadatos.apellido_paterno +
      " " +
      this.alumnos.alumnos_metadatos.apellido_materno +
      " " +
      this.alumnos.alumnos_metadatos.nombre,
      15,
      conteo_lienas,
      { align: "left" }
    );
    conteo_lienas += 5;
    doc.text(
      "MATRICULA: " + this.alumnos.matricula,
      15,
      conteo_lienas,
      { align: "left" }
    );
    doc.text(
      this.periodos_escolares.tipos_periodos.nombre_para_mostrar +
      ": " +
      dato[0].nivel,
      70,
      conteo_lienas,
      { align: "left" }
    );
    doc.text(
      "GRUPO: " +
      this.grupos_niveles[nivel].clave +
      " " +
      this.grupos_niveles[nivel].nivel +
      " " +
      this.grupos_niveles[nivel].identificador,
      125,
      conteo_lienas,
      { align: "left" }
    );
    conteo_lienas += 5;

    /*var columns = [
      { title: "    ", dataKey: "id" },
      {
        title: "                                                           ",
        dataKey: "materia"
      }
    ];
    var conteo = 1;
    dato[0].calificaciones.forEach(par => {
      columns.push({
        title: "Parcial " + conteo,
        dataKey: "parcial" + conteo
      });
      conteo++;
    });
    columns.push({
      title: "            ",
      dataKey: "promedio"
    });

    (doc as any).autoTable(columns, [], {
      didParseCell: function(cell, data) {
        cell.styles.fillColor = "#ffffff";
      },
      startY: conteo_lienas,
      styles: {
        halign: "center",
        fillColor: color
      },
      theme: "grid",
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 60 }
      }
    });
    conteo_lienas += 5;*/

    var columns = [
      { title: "N", dataKey: "id" },
      { title: "Materias", dataKey: "materia" }
    ];
    var conteo = 1;
    dato[0].calificaciones.forEach(par => {
      columns.push({
        title: "Parcial " + conteo,
        dataKey: "parcial" + conteo
      });
      /*columns.push({
        title: "F ",
        dataKey: "falta" + conteo
      });*/
      conteo++;
    });
    columns.push({
      title: "Prom",
      dataKey: "promedio" + conteo
    });

    var rows = [];
    var linea = 1;
    dato.forEach(par => {
      rows.push({
        id: linea,
        materia: par.nombre
      });

      conteo = 1;
      dato[linea - 1].calificaciones.forEach(par => {
        rows[linea - 1]["parcial" + conteo] = par.calificacion
          ? par.calificacion
          : "--";
        //rows[linea - 1]["falta" + conteo] = "";
        conteo++;
      });
      rows[linea - 1]["promedio" + conteo] = par.promedio;
      linea++;
    });
    var esto = this;
    (doc as any).autoTable({
            columns:columns, 
            body: rows,
      didParseCell : function (cell) {
              let value = cell;
              cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
        if ((value.cell.text * 1) < (esto.carrera_modulo_nivel[dato[0].nivel].minimo_aprobatorio * 1) && value.column.dataKey != "id") {
          cell.styles.textColor = "#e11d1d";
        };
      },
      startY: conteo_lienas,
      styles: {
        fontSize: 8,
        halign: "center",
        fillColor: color
      },
      theme: "grid",
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 60 },
        materia: {
          halign: "left"
        }
      }
    });

    conteo_lienas += 7 * linea;
    columns = [];
    columns.push(
      { title: "    ", dataKey: "id" },
      { title: "PROMEDIO GENERAL:", dataKey: "materia" },
      { title: this.dato[0][dato[0].nivel], dataKey: "dato" }
    );

    (doc as any).autoTable(columns, [], {
      didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
      },
      startY: conteo_lienas,
      styles: {
        fontSize: 8,
        halign: "center",
        fillColor: color
      },
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 60 },
        2: {
          halign: "right"
        }
      }
    });

    conteo_lienas += 10;

    if (footer) {
      footer.forEach(element => {
        var columna = 5;
        var fila = 5;
        var col = 0;
        var fil = 0;
        var col_no = 0;
        var ancho = 0;
        var alto = 0;
        element.estructuras_contenidos.forEach(elem => {
          ancho = 216 * (elem.ancho_porcentaje / 100);
          alto = 279 * (elem.alto_porcentaje / 100);
          col_no = 0;
          if (elem.tipo == "FOTO") {
            doc.addImage(
              elem.logo,
              "PNG",
              columna,
              fila,
              ancho,
              alto,
              "",
              "FAST"
            );
          } else {
            let contenido = elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                    contenido =
                      "<div style='line-height: 20px;'>" +
                      contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                      "</div>";
                      
                    doc.fromHTML(elem.contenido, columna, conteo_lienas, {
                      width: ancho + columna
                    });
          }
          columna += ancho + 1;
          col++;

          if (element.columnas == col) {
            col = 0;
            conteo_lienas += alto;
            columna = 5;
            col_no = 1;
          }
        });
        if (col_no == 0) conteo_lienas += alto;
      });
    }
    moment.locale("es");
    var fecha =
      this.configuracion.sucursal.direccion +
      " A " +
      moment(new Date()).format("dddd [,] D [de] MMMM [del] YYYY");
    doc.text(fecha.toUpperCase(), 200, 260, { align: "right" });

    // doc.autoPrint();
    //const string = (doc as any).output("datauristring", "boleta.pdf");
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe =
      "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
      string +
      "'></iframe>";

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  imprimirBoletaPromedio(dato) {
    let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");

    var doc = new jsPDF("p", "mm", "letter");

    var header = this.documentos["BOLETAS PARCIALES"]["HEADER"];
    var body = this.documentos["BOLETAS PARCIALES"]["BODY"];
    var footer = this.documentos["BOLETAS PARCIALES"]["FOOTER"];

    var conteo_lienas = 4;
    if (header) {
      header.forEach(element => {
        var columna = 5;
        var fila = 5;
        var col = 0;
        var fil = 0;
        var col_no = 0;
        var ancho = 0;
        var alto = 0;
        element.estructuras_contenidos.forEach(elem => {
          ancho = 216 * (elem.ancho_porcentaje / 100);
          alto = 279 * (elem.alto_porcentaje / 100);
          col_no = 0;
          if (elem.tipo == "FOTO") {
            doc.addImage(
              elem.logo,
              "PNG",
              columna,
              fila,
              ancho,
              alto,
              "",
              "FAST"
            );
          } else {
            let contenido = elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                    contenido =
                      "<div style='line-height: 20px;'>" +
                      contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                      "</div>";
                      
                    doc.fromHTML(elem.contenido, columna, conteo_lienas, {
                      width: ancho + columna
                    });
          }
          columna += ancho + 1;
          col++;

          if (element.columnas == col) {
            col = 0;
            conteo_lienas += alto;
            columna = 5;
            col_no = 1;
          }
        });
        if (col_no == 0) conteo_lienas += alto;
      });
    }
    if (body) {
      body.forEach(element => {
        var columna = 5;
        var fila = 5;
        var col = 0;
        var fil = 0;
        var col_no = 0;
        var ancho = 0;
        var alto = 0;
        element.estructuras_contenidos.forEach(elem => {
          ancho = 216 * (elem.ancho_porcentaje / 100);
          alto = 279 * (elem.alto_porcentaje / 100);
          col_no = 0;
          if (elem.tipo == "FOTO") {
            doc.addImage(
              elem.logo,
              "PNG",
              columna,
              fila,
              ancho,
              alto,
              "",
              "FAST"
            );
          } else {
            let contenido = elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                    contenido =
                      "<div style='line-height: 20px;'>" +
                      contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                      "</div>";
                      
                    doc.fromHTML(elem.contenido, columna, conteo_lienas, {
                      width: ancho + columna
                    });
          }
          columna += ancho + 1;
          col++;

          if (element.columnas == col) {
            col = 0;
            conteo_lienas += alto;
            columna = 5;
            col_no = 1;
          }
        });
        if (col_no == 0) conteo_lienas += alto;
      });
    }

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "bold");
    let nivel = dato[0].nivel;
    doc.text(
      "BOLETA " + this.periodos_escolares.tipos_periodos.nombre.toUpperCase(),
      108,
      conteo_lienas,
      { align: "center" }
    );
    conteo_lienas += 10;
    doc.text(
      "NIVEL: " + this.carrera_plan.carreras.nivel_educativo.toUpperCase(),
      15,
      conteo_lienas,
      { align: "left" }
    );
    conteo_lienas += 5;
    doc.text(
      "CARRERA: " +
      this.carrera_plan.carreras.nombre +
      " - " +
      this.carrera_plan.planes_estudios.nombre,
      15,
      conteo_lienas,
      { align: "left" }
    );
    doc.text(
      "TURNO: " + this.alumnos.grupos.turnos.nombre,
      125,
      conteo_lienas,
      { align: "left" }
    );
    conteo_lienas += 5;
    doc.text(
      "CLAVE: " + this.carrera_plan.carreras.sigla,
      15,
      conteo_lienas,
      { align: "left" }
    );
    doc.text(
      "CICLO: " + this.periodos_escolares_niveles[nivel].nombre,
      125,
      conteo_lienas,
      { align: "left" }
    );
    conteo_lienas += 8;

    doc.text(
      "NOMBRE: " +
      this.alumnos.alumnos_metadatos.apellido_paterno +
      " " +
      this.alumnos.alumnos_metadatos.apellido_materno +
      " " +
      this.alumnos.alumnos_metadatos.nombre,
      15,
      conteo_lienas,
      { align: "left" }
    );
    conteo_lienas += 5;
    doc.text(
      "MATRICULA: " + this.alumnos.matricula,
      15,
      conteo_lienas,
      { align: "left" }
    );
    doc.text(
      this.periodos_escolares.tipos_periodos.nombre_para_mostrar +
      ": " +
      dato[0].nivel,
      70,
      conteo_lienas,
      { align: "left" }
    );
    doc.text(
      "GRUPO: " +
      this.grupos_niveles[nivel].clave +
      " " +
      this.grupos_niveles[nivel].nivel +
      " " +
      this.grupos_niveles[nivel].identificador,
      125,
      conteo_lienas,
      { align: "left" }
    );
    conteo_lienas += 5;

    var columns = [
      { title: "    ", dataKey: "id" },
      {
        title: "                                                           ",
        dataKey: "materia"
      }
    ];
    var conteo = 1;

    columns.push({
      title: "            ",
      dataKey: "promedio"
    });
    var esto = this;
    (doc as any).autoTable(columns, [], {
      didParseCell : function (cell) {
              let value = cell;
              cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
        if ((value.cell.text * 1) < (esto.carrera_modulo_nivel[dato[0].nivel].minimo_aprobatorio * 1) && value.column.dataKey != "id") {
          cell.styles.textColor = "#e11d1d";
        };
      },
      startY: conteo_lienas,
      styles: {
        halign: "center",
        fillColor: color
      },
      theme: "grid",
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 60 }
      }
    });
    conteo_lienas += 5;

    var columns = [
      { title: "N", dataKey: "id" },
      { title: "Materias", dataKey: "materia" }
    ];
    var conteo = 1;

    columns.push({
      title: "Prom",
      dataKey: "promedio" + conteo
    });

    var rows = [];
    var linea = 1;
    dato.forEach(par => {
      rows.push({
        id: linea,
        materia: par.nombre
      });

      conteo = 1;

      rows[linea - 1]["promedio" + conteo] = par.promedio;
      linea++;
    });

    (doc as any).autoTable({
            columns:columns, 
            body: rows,
      didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
      },
      startY: conteo_lienas,
      styles: {
        fontSize: 8,
        halign: "center",
        fillColor: color
      },
      theme: "grid",
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 60 },
        materia: {
          halign: "left"
        }
      }
    });

    conteo_lienas += 7 * linea;
    columns = [];
    columns.push(
      { title: "    ", dataKey: "id" },
      { title: "PROMEDIO GENERAL:", dataKey: "materia" },
      { title: this.dato[0][dato[0].nivel], dataKey: "dato" }
    );

    (doc as any).autoTable(columns, [], {
      didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
      },
      startY: conteo_lienas,
      styles: {
        fontSize: 8,
        halign: "center",
        fillColor: color
      },
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 60 },
        2: {
          halign: "right"
        }
      }
    });

    conteo_lienas += 10;

    if (footer) {
      footer.forEach(element => {
        var columna = 5;
        var fila = 5;
        var col = 0;
        var fil = 0;
        var col_no = 0;
        var ancho = 0;
        var alto = 0;
        element.estructuras_contenidos.forEach(elem => {
          ancho = 216 * (elem.ancho_porcentaje / 100);
          alto = 279 * (elem.alto_porcentaje / 100);
          col_no = 0;
          if (elem.tipo == "FOTO") {
            doc.addImage(
              elem.logo,
              "PNG",
              columna,
              fila,
              ancho,
              alto,
              "",
              "FAST"
            );
          } else {
            let contenido = elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                    contenido =
                      "<div style='line-height: 20px;'>" +
                      contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                      "</div>";
                      
                    doc.fromHTML(elem.contenido, columna, conteo_lienas, {
                      width: ancho + columna
                    });
          }
          columna += ancho + 1;
          col++;

          if (element.columnas == col) {
            col = 0;
            conteo_lienas += alto;
            columna = 5;
            col_no = 1;
          }
        });
        if (col_no == 0) conteo_lienas += alto;
      });
    }
    moment.locale("es");
    var fecha =
      this.configuracion.sucursal.direccion +
      " A " +
      moment(new Date()).format("dddd [,] D [de] MMMM [del] YYYY");
    doc.text(fecha.toUpperCase(), 200, 260, { align: "right" });

    // doc.autoPrint();
    //const string = (doc as any).output("datauristring", "boleta_parcial.pdf");
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe =
      "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
      string +
      "'></iframe>";

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  logo_sucursal = "";
  logo_empresa = "";
  logo_carrera = "";
  imprimirKardex(dato) {
    let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");

    var doc = new jsPDF("p", "mm", "legal");

    var conteo_lienas = 4;

    var logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
    if (logo != "")
      doc.addImage(logo, "PNG", 10, 5, 28, 18,  "center" );
    //Nombre empresa

    doc.setFontSize(15);
    doc.setFont("helvetica", "", "bold");
    doc.setFont("helvetica");
    doc.text(this.configuracion.empresa.nombre, 108, 12, { align: "center" });

    doc.setFontSize(14);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.empresa.subnombre, 108, 18, { align: "center" });

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "normal");
    doc.text("Campus: " + this.configuracion.sucursal.nombre, 108, 24, { align: "center" });

    conteo_lienas += 28;
    doc.setFontSize(10);
    doc.setFont("helvetica", "", "bold");

    doc.text("KARDEX", 110, conteo_lienas, { align: "center" });
    conteo_lienas += 5;
    doc.setFontSize(6);
    doc.text("CARRERA: " + this.carrera_plan.carreras.nombre + " - " + this.carrera_plan.planes_estudios.nombre, 15, conteo_lienas, { align: "left" });
    doc.text("CLAVE: " + this.carrera_plan.carreras.sigla, 155, conteo_lienas, { align: "left" });
    conteo_lienas += 3;

    doc.text("NOMBRE: " + this.alumnos.alumnos_metadatos.apellido_paterno + " " + this.alumnos.alumnos_metadatos.apellido_materno + " " + this.alumnos.alumnos_metadatos.nombre, 15, conteo_lienas, { align: "left" });

    doc.text("TURNO: " + this.alumnos.grupos.turnos.nombre, 155, conteo_lienas, { align: "left" });

    conteo_lienas += 3;
    doc.text(
      "MATRICULA: " + this.alumnos.matricula,
      15,
      conteo_lienas,
      { align: "left" }
    );

    doc.text(
      "GRUPO: " +
      this.alumnos.grupos.clave +
      " " +
      this.alumnos.grupos.nivel +
      " " +
      this.alumnos.grupos.identificador,
      155,
      conteo_lienas,
      { align: "left" }
    );
    conteo_lienas += 2;
    var conteo_lin = [];
    conteo_lin[0] = conteo_lienas;
    conteo_lin[1] = conteo_lienas;
    var columns1 = [];
    var rows1 = [];
    var columns2 = [];
    var rows2 = [];
    var columns3 = [];
    var rows3 = [];
    for (var key in dato) {
      var c = parseInt(key);
      if (c > 0) {
        columns1 = [
          {
            title:
              this.periodos_escolares.tipos_periodos.nombre_para_mostrar +
              ": " +
              key,
            dataKey: "nivel"
          },
          {
            title:
              "Periodo: " +
              this.carrera_modulo_nivel[key].modulos_periodos_escolares
                .periodos_escolares.nombre,
            dataKey: "periodo"
          }
        ];

        columns2 = [
          { title: "                                ", dataKey: "mate" },
          { title: "Calif.", dataKey: "calif" },
          { title: "Regularización ", dataKey: "regula" },
          { title: "    ", dataKey: "obs" }
        ];

        columns3 = [
          { title: "Materia", dataKey: "materia" },
          { title: "Final.", dataKey: "calif" },
          { title: "Ext. ", dataKey: "ext" },
          { title: "T.S ", dataKey: "ts" },
          { title: "Otros. ", dataKey: "otro" },
          { title: "Obs. ", dataKey: "obs" }
        ];
        rows3 = [];
        dato[key].forEach(elem => {
          rows3.push({
            materia: elem.nombre,
            calif: elem.promedio,
            ext: "",
            ts: "",
            otro: "",
            obs: ""
          });
        });

        if (c % 2 == 0) {
          if (conteo_lin[1] + rows3.length * 6.8 > 356) {
            conteo_lin[0] = 10;
            conteo_lin[1] = 10;
            conteo_lienas = 10;
            doc.addPage();
          }
          (doc as any).autoTable(columns1, rows1, {
            createdHeaderCell: function (cell, data) {
              cell.styles.halign = "left";
            },
            tableWidth: 92,
            margin: { left: 108 },
            startY: conteo_lin[1],
            styles: {
              fontSize: 5,
              fillColor: color
            },
            theme: "grid",
            columnStyles: {
              0: { cellWidth: 50 },
              1: { cellWidth: 50 }
            }
          });
          conteo_lin[1] += 4;
          (doc as any).autoTable(columns2, rows2, {
            tableWidth: 92,
            margin: { left: 108 },
            startY: conteo_lin[1],
            styles: {
              fontSize: 5,
              halign: "center"
            },
            theme: "grid",
            columnStyles: {
              mate: {
                halign: "left",
                cellWidth: 42
              },
              calif: { cellWidth: 10 },
              regula: { cellWidth: 30 },
              obs: { cellWidth: 10 }
            },
            headStyles: {
              cellPadding: 2,
              lineWidth: 0,
              valign: "top",
              fontStyle: "bold",
              fillColor: "#ddd9d9",
              textColor: "#000000",
              lineColor: "#000000"
            },
            bodyStyles: {
              lineColor: "#000000"
            }
          });
          conteo_lin[1] += 4;
          (doc as any).autoTable(columns3, rows3, {
            didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
              cell.styles.fillColor = "#ffffff";
              cell.styles.fontColor = "#000000";
            },
            tableWidth: 92,
            margin: { left: 108 },
            startY: conteo_lin[1],
            styles: {
              fontSize: 4.5,
              halign: "center",
              fillColor: "#ddd9d9",
              fontColor: "#000000"
            },
            theme: "grid",
            columnStyles: {
              materia: {
                halign: "left",
                cellWidth: 42
              },
              calif: { cellWidth: 10 },
              ext: { cellWidth: 10 },
              ts: { cellWidth: 10 },
              otro: { cellWidth: 10 },
              obs: { cellWidth: 10 }
            },
            headStyles: {
              cellPadding: 2,
              lineWidth: 0,
              valign: "top",
              fontStyle: "bold",
              fillColor: "#ddd9d9",
              textColor: "#000000",
              lineColor: "#000000"
            }
          });
          conteo_lin[1] += rows3.length * 6.8;
        } else {
          if (conteo_lin[0] + rows3.length * 6.8 > 356) {
            conteo_lin[0] = 10;
            conteo_lin[1] = 10;
            conteo_lienas = 10;
            doc.addPage();
          }
          (doc as any).autoTable(columns1, rows1, {
            createdHeaderCell: function (cell, data) {
              cell.styles.halign = "left";
            },
            tableWidth: 92,
            startY: conteo_lin[0],
            styles: {
              fontSize: 5,
              fillColor: color
            },
            theme: "grid",
            columnStyles: {
              0: { cellWidth: 50 },
              1: { cellWidth: 50 }
            }
          });
          conteo_lin[0] += 4;
          (doc as any).autoTable(columns2, rows2, {
            didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
              cell.styles.fillColor = "#ffffff";
              cell.styles.fontColor = "#000000";
            },
            tableWidth: 92,
            startY: conteo_lin[0],
            styles: {
              fontSize: 5,
              halign: "center"
            },
            theme: "grid",
            columnStyles: {
              mate: {
                halign: "left",
                cellWidth: 42
              },
              calif: { cellWidth: 10 },
              regula: { cellWidth: 30 },
              obs: { cellWidth: 10 }
            },
            headStyles: {
              cellPadding: 2,
              lineWidth: 0,
              valign: "top",
              fontStyle: "bold",
              fillColor: "#ddd9d9",
              textColor: "#000000",
              lineColor: "#000000"
            },
            bodyStyles: {
              lineColor: "#000000"
            }
          });
          conteo_lin[0] += 4;
          (doc as any).autoTable(columns3, rows3, {
            didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
              cell.styles.fillColor = "#ffffff";
              cell.styles.fontColor = "#000000";
            },
            tableWidth: 92,
            startY: conteo_lin[0],
            styles: {
              fontSize: 4.5,
              halign: "center",
              fillColor: "#ddd9d9",
              fontColor: "#000000"
            },
            theme: "grid",
            columnStyles: {
              materia: {
                halign: "left",
                cellWidth: 42
              },
              calif: { cellWidth: 10 },
              ext: { cellWidth: 10 },
              ts: { cellWidth: 10 },
              otro: { cellWidth: 10 },
              obs: { cellWidth: 10 }
            },
            headStyles: {
              cellPadding: 2,
              lineWidth: 0,
              valign: "top",
              fontStyle: "bold",
              fillColor: "#ddd9d9",
              textColor: "#000000",
              lineColor: "#000000"
            }
          });
          conteo_lin[0] += rows3.length * 6.8;
        }
      }
    }

    // doc.autoPrint();
    //const string = (doc as any).output("datauristring", "kardex.pdf");
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe =
      "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
      string +
      "'></iframe>";

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo_carrera = logos.carrera;
    }
  }
}
